<template>
  <div class="auth-header">
    <router-link to="/about" tag="a" class="w3-bar-item w3-button w3-theme-d4" style="padding:10px 12px 10px 12px">
      <img src='../assets/jybe_lg.svg' height='30px' />
    </router-link>
    <a @click="login()" class="w3-bar-item w3-button w3-right w3-padding-large w3-hover-white w3-hide-small" title="Login">
      Login
    </a>
    <div id="navDemo" class="w3-bar-block w3-theme-d2 w3-right w3-hide-large w3-hide-medium w3-large">
      <a @click="login()" class="w3-bar-item w3-button w3-padding-large w3-hover-white" title="Login">
        Login
      </a>
    </div>

  </div>
</template>

<script>
  import NonAuthHeader from './NonAuthHeader.ts'
  export default NonAuthHeader
</script>
